module.exports = __webpack_public_path__ + "static/img/logo-home.96ab16ee.svg";